var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section has-text-centered"},[_vm._m(0),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-large"},[_c('i',{staticClass:"fas fa-3x fa-spinner fa-pulse"})])
}]

export { render, staticRenderFns }